import { Component, Host, Prop,State,  h, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'jump-tab-item',
  styleUrl: 'jump-tab-item.scss',
  shadow: true,
})
export class JumpTabItem {

  /* ---------------------- @PROPERTIES ------------------------- */

  /**
   * Identifier of the tab
   */
  @Prop() identifier: string = undefined;

  /**
   * Name of the icon. If not provided, the icon will not be displayed
   */
  @Prop() iconName: string = undefined;

  /**
   * Icon position, apply only if the icon is present
   * Choosed from "left", "top"
   */
  @Prop() iconPosition: string = 'left';
  @Prop() label: string = '';
  @Prop() active: boolean = false;

  @Prop() disabled: boolean = false;

  /**
   * The style of the tab item
   * Choosed from "inline", "boxed", "sheet", "rounded"
   */
  @State() variant: string = 'inline';

  @Event({ eventName: 'jump-change-active-tab' }) changeActiveTab: EventEmitter;

  changeTab(identifier){
    this.changeActiveTab.emit({id: identifier});
  }

  componentDidLoad() {
    // Deve leggere la prop "variant" del componente babbo jump-tab e popolare la propria prop "variant"
    let parentVariant = this.tabEl.parentElement.getAttribute('variant');
    this.variant = parentVariant;
  }

  tabEl: HTMLElement;

  render() {
    return (
      <Host
        ref={(el) => { this.tabEl = el }}
        class={"JumpTabItem " + (this.active ? 'active' : '') + " " + (this.variant) + " " + (this.disabled ? 'disabled' : '')}>
        <div class={"Content " + (this.iconName ? this.iconPosition : '') + " " + (this.variant) + " " + (this.active ? 'active' : '') + " " + (this.disabled ? 'disabled' : '')} onClick={() => this.changeTab(this.identifier)} id={this.identifier}>
          {(this.iconName && (this.variant == 'inline' || this.variant == 'boxed')) &&
            <jump-icon library="fa" category="regular" name={this.iconName} size="small"></jump-icon>
          }
          <span class="label">{this.label}</span>
        </div>
      </Host>
    );
  }
}

